var _excluded = ["className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import { DownOutlined } from '@aelf-design/icons';
import { Collapse as AntdCollapse } from 'antd';
import useStyles from "./style";
var InternalCollapse = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    st = _useStyles.styles,
    cx = _useStyles.cx;
  return /*#__PURE__*/React.createElement(AntdCollapse, _extends({}, rest, {
    expandIcon: function expandIcon(_ref2) {
      var isActive = _ref2.isActive;
      return /*#__PURE__*/React.createElement(DownOutlined, {
        className: cx(isActive && st.collapseIcon)
      });
    },
    expandIconPosition: 'end',
    className: cx(st.aelfdCollapse, className),
    ref: ref
  }));
});
if (process.env.NODE_ENV !== 'production') {
  InternalCollapse.displayName = 'Collapse';
}
var Collapse = InternalCollapse;
Collapse.Panel = AntdCollapse.Panel;
export default Collapse;